var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"user-list-expand"},[_c('Tableview',{attrs:{"fields":_vm.tableHeaders,"items":_vm.data.clients}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }